import axios from 'utils/axios';

// Get all clients
export const getAnalytics = async () => {
    const response = await axios.get(`analytics`, {
        params: {}
    });
    return response.data;
};
